exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".RadioToggle-default-2XR69{border:1px solid transparent;border-radius:4px}.RadioToggle-error-20LTf{border-color:#ff5766}", ""]);

// exports
exports.locals = {
	"default": "RadioToggle-default-2XR69",
	"error": "RadioToggle-error-20LTf"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/RadioToggle.less
// module id = 1654
// module chunks = 0